module.exports = __webpack_public_path__ + "static/media/bg_bj.1daac32b.png";